var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-flex',{attrs:{"row":"","wrap":"","mt-3":"","px-5":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }